import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'problem-behavior',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './problem-behavior.component.html',
  styleUrl: './problem-behavior.component.css'
})
export class ProblemBehaviorComponent implements OnInit, OnChanges {

  @Input() parentInterviewData: any;
  @Output() onSaveSection6 = new EventEmitter<any>();

  yesNo = EYesNo;
  problemBehaviorForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What was the worst thing you know of that your child did? *",
      formControlName: "worst_action",
    },
    {
      question: "How does your child handle frustration? *",
      formControlName: "frustration",
    },
    {
      question: "When your child gets angry, what does he/she do? *",
      formControlName: "child_anger_actions",
    }
  ]

  radioQuestions = [
    {
      id: 'trouble_law',
      questionText: 'Has your child been in trouble with the law or police before? *',
      formControlName: 'trouble_law',
      infoFormControlName: 'trouble_law_information'
    },
    {
      id: 'arrest',
      questionText: 'Has your child done things that could have gotten him/her arrested or in trouble with the law? *',
      formControlName: 'arrest',
      infoFormControlName: 'arrest_information'
    },
    {
      id: 'bad_things',
      questionText: 'Are there other bad things? *',
      formControlName: 'bad_things',
      infoFormControlName: 'bad_things_information'
    },
    {
      id: 'alcohol',
      questionText: 'Does your child drink beer, wine, or other alcohol? *',
      formControlName: 'alcohol',
      infoFormControlName: 'alcohol_information'
    },
    {
      id: 'drugs',
      questionText: 'Does your child use marijuana? *',
      formControlName: 'drugs',
      infoFormControlName: 'drugs_information'
    },
    {
      id: 'medication',
      questionText: 'Has your child used any other drugs or medications not prescribed to him/her? *',
      formControlName: 'medication',
      infoFormControlName: 'medication_information'
    },
    {
      id: 'fight_involvement',
      questionText: 'Has your child ever been involved in a fight? *',
      formControlName: 'fight_involvement',
      infoFormControlName: 'fight_involvement_information'
    },
    {
      id: 'child_temper',
      questionText: "Has your child's temper ever gotten him/her in trouble? *",
      formControlName: 'child_temper',
      infoFormControlName: 'child_temper_information'
    },
    {
      id: 'child_hit_family',
      questionText: "Has your child ever hit you or other family members? *",
      formControlName: 'child_hit_family',
      infoFormControlName: 'child_hit_family_information'
    },
    {
      id: 'destroy_property',
      questionText: "Has your child destroyed his/her own things or something else's property? *",
      formControlName: 'destroy_property',
      infoFormControlName: 'destroy_property_information'
    },
    {
      id: 'child_pets',
      questionText: "Does your child have pets? *",
      formControlName: 'child_pets',
      infoFormControlName: 'child_pets_information'
    },
    {
      id: 'hurt_animals',
      questionText: "Has your child ever intentionally hurt a pet or other animal? *",
      formControlName: 'hurt_animals',
      infoFormControlName: 'hurt_animals_information'
    },
    {
      id: 'items_of_concern',
      questionText: "Have you found items of concern in your child's room? *",
      formControlName: 'items_of_concern',
      infoFormControlName: 'items_of_concern_information'
    },
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.problemBehaviorForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.problemBehaviorForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.problemBehaviorForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveProblemBehavior(): void {
    if (this.problemBehaviorForm.valid) {
      this.onSaveSection6.emit(this.problemBehaviorForm.value);
    }
  }

}
